export default "__VITE_PUBLIC_ASSET__58e92847__"